import React from "react";
import PropTypes from "prop-types";
import ButtonIconText from "components/molecules/ButtonIconText";
import LoadingIndicator from "components/atoms/LoadingIndicator";
import { STYLE_TYPES as ICON_TYPES } from "components/atoms/Icon";

const ResultFoot = (props) => {
  const {
    loadingMore,
    moreButton: {
      text: btnText,
      itemCount: btnItemCount,
      showCount: btnShowCount,
      ...btnPropsRest
    },
    onResultMore,
    showMoreBtn = true,
  } = props;
  const moreBtnText = btnShowCount ? `${btnItemCount} ${btnText}` : btnText;
  const baseClassName = "sal-result-foot";
  const clickMore = (e) => {
    e.preventDefault();
    onResultMore(btnItemCount);
  };

  return (
    <div className={baseClassName}>
      {loadingMore ? (
        <LoadingIndicator className={baseClassName + "__loading-indicator"} />
      ) : null}
      {!loadingMore && showMoreBtn && (
        <ButtonIconText
          text={moreBtnText}
          onClick={clickMore}
          className={baseClassName + "__button-more"}
          iconLeft
          {...btnPropsRest}
        />
      )}
    </div>
  );
};

ResultFoot.propTypes = {
  loadingMore: PropTypes.bool,
  moreButton: PropTypes.shape({
    itemCount: PropTypes.number.isRequired,
    showCount: PropTypes.bool.isRequired,
    text: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    iconType: PropTypes.oneOf(Object.values(ICON_TYPES)),
  }).isRequired,
  onResultMore: PropTypes.func.isRequired,
  showMoreBtn: PropTypes.bool.isRequired,
};

export default ResultFoot;
